import type { INichesWithPerformanceData } from 'modules/industry-category/common/industry-category.types'
import { humanizeLargeNumber, TOLGEE_GLOBALS } from 'utils'

import type { TTotalChartEntityData } from './niche-chart-selector.types'

export const getBaseTotalChartData = (
  niches: INichesWithPerformanceData[],
  key: keyof Pick<INichesWithPerformanceData, 'totalViews' | 'totalPosts' | 'totalEngagement'>,
  getColorByEntityId: (id: string, type: string) => string
) => {
  return niches
    .map(niche => {
      return {
        name: niche.name,
        y: niche[key],
        x: humanizeLargeNumber(niche[key]),
        color: getColorByEntityId(niche.id, 'topics'),
        id: niche.id,
      }
    })
    .sort((a, b) => b.y - a.y)
}

export const getBarChartData = (
  engagementChartData: TTotalChartEntityData[],
  viewsChartData: TTotalChartEntityData[],
  t: (params: { key: string; defaultValue: string }) => void
) => {
  return [
    {
      id: 'engagement-chart-data',
      entities: engagementChartData,
      titleOptions: {
        text: String(t(TOLGEE_GLOBALS.engagement)),
        align: 'left' as const,
        style: {
          fontSize: '16px',
        },
      },
    },
    {
      id: 'views-chart-data',
      entities: viewsChartData,
      titleOptions: {
        text: String(t(TOLGEE_GLOBALS.views)),
        align: 'left' as const,
        style: {
          fontSize: '16px',
        },
      },
    },
  ]
}

export const getDonutChartData = (
  engagementShareChartData: TTotalChartEntityData[],
  viewsShareChartData: TTotalChartEntityData[],
  postsShareChartData: TTotalChartEntityData[],
  t: (params: { key: string; defaultValue: string }) => void
) => {
  const totalEngagement = engagementShareChartData.reduce((prev, curr) => {
    return prev + curr.y
  }, 0)
  const totalViews = viewsShareChartData.reduce((prev, curr) => {
    return prev + curr.y
  }, 0)
  const totalPosts = postsShareChartData.reduce((prev, curr) => {
    return prev + curr.y
  }, 0)
  return [
    {
      id: 'engagement-share-chart-data',
      entities: engagementShareChartData,
      titleOptions: {
        text: String(t(TOLGEE_GLOBALS.engagement)),
        align: 'center' as const,
      },
      centerHtmlContent: `<div style="text-align: center; color: #2B2B2B;"><div style="font-size: 14px;">${t(TOLGEE_GLOBALS.total)}</div><div style="font-size: 24px; font-weight: 600;">${humanizeLargeNumber(totalEngagement)}</div></div>`,
    },
    {
      id: 'views-share-chart-data',
      entities: viewsShareChartData,
      titleOptions: {
        text: String(t(TOLGEE_GLOBALS.views)),
        align: 'center' as const,
      },
      centerHtmlContent: `<div style="text-align: center; color: #2B2B2B;"><div style="font-size: 14px;">${t(TOLGEE_GLOBALS.total)}</div><div style="font-size: 24px; font-weight: 600;">${humanizeLargeNumber(totalViews)}</div></div>`,
    },
    {
      id: 'posts-share-chart-data',
      entities: postsShareChartData,
      titleOptions: {
        text: String(t(TOLGEE_GLOBALS.videos)),
        align: 'center' as const,
      },
      centerHtmlContent: `<div style="text-align: center; color: #2B2B2B;"><div style="font-size: 14px;">${t(TOLGEE_GLOBALS.total)}</div><div style="font-size: 24px; font-weight: 600;">${humanizeLargeNumber(totalPosts)}</div></div>`,
    },
  ]
}
